export default class extends HTMLElement {
  connectedCallback() {
    this.setupEventListeners();
    this.setupKeyboardShortcuts();
  }

  setupEventListeners() {
    // Focus handling
    this.input.addEventListener("focus", () => {
      if (this.title) {
        this.title.classList.add("hidden", "md:block");
      }
      this.closest("form").classList.add("bg-base-200/50");

      // Show the real placeholder and hide the custom placeholder
      this.input.placeholder = this.input.dataset.placeholder;
      if (this.customPlaceholder) {
        this.customPlaceholder.classList.add("opacity-0");
      }
    });

    this.input.addEventListener("blur", (e) => {
      if (this.title && !e.target.value) {
        this.title.classList.remove("hidden");
      }

      // Hide the real placeholder and show the custom placeholder if input is empty
      if (!e.target.value) {
        this.input.placeholder = "";
        if (this.customPlaceholder) {
          this.customPlaceholder.classList.remove("opacity-0");
        }
      }

      // Small delay to allow for clicking the search button
      setTimeout(() => {
        if (document.activeElement !== this.searchButton) {
          this.closest("form").classList.remove("bg-base-200/50");
        }
      }, 100);
    });

    // Add clear button functionality when typing
    this.input.addEventListener("input", () => {
      this.updateClearButtonVisibility();

      // Hide custom placeholder when typing
      if (this.customPlaceholder && this.input.value) {
        this.customPlaceholder.classList.add("opacity-0");
      } else if (this.customPlaceholder && !this.input.value) {
        this.customPlaceholder.classList.remove("opacity-0");
      }
    });
  }

  setupKeyboardShortcuts() {
    // Global keyboard shortcut (Ctrl+K or Cmd+K) to focus search
    document.addEventListener("keydown", (e) => {
      // Check if Ctrl+K or Cmd+K is pressed and not in an input field
      if (
        (e.ctrlKey || e.metaKey) &&
        e.key === "k" &&
        !["INPUT", "TEXTAREA", "SELECT"].includes(
          document.activeElement.tagName
        )
      ) {
        e.preventDefault();
        this.input.focus();
      }

      // Escape key to blur search when focused
      if (e.key === "Escape" && document.activeElement === this.input) {
        this.input.blur();
        this.input.value = "";
        this.updateClearButtonVisibility();
      }
    });
  }

  updateClearButtonVisibility() {
    const clearButton = this.closest("form").querySelector(
      "a[title=\"<%= t('clear') %>\"]"
    );
    if (clearButton && this.input.value) {
      if (!clearButton.parentElement.classList.contains("visible")) {
        const buttonContainer = document.createElement("div");
        buttonContainer.className = "absolute right-3";
        buttonContainer.innerHTML = `
          <a href="${window.location.pathname}" 
             title="Clear" 
             class="flex items-center justify-center w-6 h-6 text-neutral-content/70 hover:text-error hover:bg-base-300 rounded-full transition-colors">
            <span aria-hidden="true">&times;</span>
          </a>
        `;
        this.closest("form").appendChild(buttonContainer);

        // Add click event to the new clear button
        buttonContainer.querySelector("a").addEventListener("click", (e) => {
          e.preventDefault();
          this.input.value = "";
          this.input.focus();
          buttonContainer.remove();
        });
      }
    } else if (clearButton && !this.input.value) {
      clearButton.parentElement.classList.add("hidden");
    }
  }

  get input() {
    return this.querySelector("input");
  }

  get title() {
    return document.querySelector(this.dataset.title);
  }

  get searchButton() {
    return this.closest("form").querySelector('button[type="submit"]');
  }

  get customPlaceholder() {
    return this.querySelector(".search-placeholder");
  }
}
